import { Tc, PagingResultsViewModel, EnumSiNoTodos, FilterSearchingBaseViewModel } from '../../../core/_infrastructure/types/common';

export class PuntoInspeccionItemResultsViewModel extends PagingResultsViewModel {
    public ResultList: PuntoInspeccionItemViewModel[];
}

export class PuntoInspeccionItemViewModel {
    public Id: number;
    public IdPaisDescripcion: string;
    public IdProvinciaDescripcion: string;
    public Codigo: string;
    public Descripcion: string;
    public IdTipoPuntoInspeccionDescripcion: string;
    public IdMunicipioDescripcion: string;
    public Email: string;
    public CodigoTraces: string;
    public Activo = true;
    public HabilitadoParaImportacion = true;
    public HabilitadoParaExportacion = true;
    public HabilitadoSanidadExterior: true;
    public CodigoPostal: string;
    public Localidad: string;
    public ReasignableEx = true;
    public FinesDeSemana = true;
    public NumeroInspectores = true;
    public PorcentajeSemanal: number;
}

export class PuntoInspeccionViewModel {
    constructor() {
        this.TAduanaCollection = [];
        this.TIntervaloHoraPuntoInspeccionCollection = [];
        this.TUbicacionCollection = [];
    }

    public Id: number;
    public IdPais: number;
    public IdProvincia: number | null = null;
    public Codigo = '';
    public Descripcion = '';
    public IdTipoPuntoInspeccion: number | null = null;
    public IdMunicipio: number | null = null;
    public HabilitadoParaImportacion: boolean;
    public HabilitadoParaExportacion: boolean;
    public HabilitadoParaTercerPais: boolean;
    public HabilitadoSanidadExterior: boolean;
    public ReasignableEx: boolean;
    public FinesDeSemana: boolean;
    public NumeroInspectores: boolean;
    public Inhabilitado: boolean;
    public IdZona: number | null = null;
    public Email = '';
    public CodigoTraces = '';
    public Activo: boolean;
    public CodigoPostal = '';
    public Localidad = '';
    public PorcentajeSemanal: number;

    public TAduanaCollection: TAduanaViewModel[];
    public TIntervaloHoraPuntoInspeccionCollection: TInterValoHoraPuntoInspeccionViewModel[];
    public TUbicacionCollection: TUbicacionViewModel[];
    public TcTipoPuntoInspeccion: Tc;
}

export class FilterSearchingPuntoInspeccionViewModel extends FilterSearchingBaseViewModel {
    public Descripcion = '';
    public Codigo = '';
    public CodigoTraces = '';
    public IdPais: number | null = null;
    public IdProvincia: number | null = null;
    public IdMunicipio: number | null = null;
    public IdTipoPuntoInspeccion: number | null = null;
    public Localidad = '';
    public CodigoPostal = '';
    public Activo: number = EnumSiNoTodos.TODOS;
    public HabilitadoParaImportacion: number = EnumSiNoTodos.TODOS;
    public HabilitadoParaExportacion: number = EnumSiNoTodos.TODOS;
    public HabilitadoSanidadExterior: number = EnumSiNoTodos.TODOS;
    public ReasignableEx: number = EnumSiNoTodos.TODOS;
}

export class TUbicacionViewModel {
    public Id: number;
    public IdPuntoInspeccion: number | null = null;
    public Descripcion = '';
    public HabilitadaImportacion: boolean;
    public HabilitadaExportacion: boolean;
    public PorDefecto: boolean;
}
export class TAduanaViewModel {
    public Id: number;
    public IdPuntoInspeccion: number;
    public Descripcion: string;
}
export class TInterValoHoraPuntoInspeccionViewModel {
    public Id: number;
    public IdPuntoInspeccion: number;
    public HoraInicio: string;
    //public MinutoInicio: string;
}

export class PuntoInspeccionUsuarioViewModel {
    public Id: number;
    public IdProvincia: number;
    public Codigo: string;
    public Descripcion: string;
}
